import { useQuery } from '@tanstack/react-query';

import { RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { ConfigBi } from 'pages/bi/types';

export function useQueryBi() {
    const requestListagem = useRequestListagem();

    const requestOptions: RequestOptionsType = {
        url: '/config/configbiwrapper/loja',
        columns: 'idConfigBi,dsConfigBi,dsUrl,dsUrlMobile,vlAltura,vlAlturaMobile',
    };

    return useQuery<ConfigBi[]>([requestOptions], () => requestListagem(requestOptions).then((res) => res.data.data));
}
